"use strict";

angular.module('PatientApp').factory('PaymentFormsService', function (Models, VuexStore) {
  return {
    getInstance: function getInstance() {
      return new Models.PaymentForm(VuexStore);
    }
  };
});